import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['maskArea', 'localeSelect', 'currencySelect']

  currencyMappingValue = {
    'en': 'USD',
    'zh-TW': 'TWD',
    'jp': 'JPY',
    'zh-CN': 'USD',
    'default': 'USD'
  }

  connect() {
    document.body.addEventListener('click', () => {
      this.hiddenDisplay()
    })

    window.addEventListener('closeAllDropdowns', this.hiddenDisplayBound = this.hiddenDisplay.bind(this))
  }

  disconnect() {
    window.removeEventListener('closeAllDropdowns', this.hiddenDisplayBound)
  }

  localeSwitchBtnClicked(e) {
    e.preventDefault()
    e.stopPropagation()

    // 廣播關閉所有 dropdown
    window.dispatchEvent(new Event('closeAllDropdowns'))

    // 再打開自己
    this.toggleDisplay()
  }

  langBtnClicked(e) {
    const url = window.location.origin + window.location.pathname
    var newUrl = new URL(url);

    const locale = e.currentTarget.dataset.localeSwitchValue

    if (!url.includes(`/${locale}/`)) {
      newUrl.searchParams.set('set_locale', locale)
      newUrl.searchParams.set('currency', this.currencyMappingValue[locale])

      window.location = newUrl.href
    }
  }

  currencyBtnClicked(e) {
    const url = window.location.origin + window.location.pathname
    var newUrl = new URL(url);

    newUrl.searchParams.set('currency', e.currentTarget.dataset.localeSwitchValue)
    window.location = newUrl.href
  }

  hiddenDisplay() {
    this.element.classList.add('close')
    this.maskAreaTarget.classList.add('hidden')
  }

  toggleDisplay() {
    this.element.classList.toggle('close')
    this.maskAreaTarget.classList.toggle('hidden')
  }
}
